import { render, staticRenderFns } from "./GeneralSettingsQuote.vue?vue&type=template&id=264c2836&"
import script from "./GeneralSettingsQuote.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsQuote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports